import { faBuildingUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { CardActionArea, Stack, Tooltip, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../../colors';
import { validatePhoneNumber } from '../../utils/helpers';
import SelectableCardContentRow from '../SelectableCardContentRow';

function ContactsAccordian({ contact, isAdmin, setIsVisible, setSelectedContact }) {
  const accordionStyle = {
    borderRadius: '20px',
    border: `1px solid ${Colors.blue}`,
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
    width: '400px',
    maxWidth: '100%',
  }

  const nameStyle = {
    fontWeight: '500',
    fontSize: '1.2rem'
  }

  const rowStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }

  const phoneStyle = { width: '33px', height: '33px', marginRight: '20px' }
  const departmentStyle = { width: '33px', height: '33px', color: Colors.green, marginRight: '20px' }
  const commentStyle = { width: '33px', height: '33px', color: 'purple', marginRight: '20px' }
  const StyledEditIcon = styled(BorderColorIcon)({
    width: '1.5rem',
    height: '2rem',
    marginLeft: '93%',
    color: Colors.mediumGray

  });
  const makeCall = (e, number) => {
    e.stopPropagation();
    const phoneNumberValue = (number || '').trim();
    if (phoneNumberValue && validatePhoneNumber(number)) {
      window.open(`tel:${phoneNumberValue}`, '_self');
    } else {
      window.alert("Please enter a valid number");
    }
  }
  const handleEditClick = () => {
    if (!isAdmin) return;
    setSelectedContact(contact)
    setIsVisible(true)
  }

  return (
    <div style={{ maxWidth: '100%' }}>
      <Accordion style={accordionStyle}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
          <PermContactCalendarIcon style={{ color: Colors.blue, width: '38px', height: '38px' }} />

          <Stack sx={{ width: '100%', marginLeft: '20px' }}>
            <span style={nameStyle}>{contact.name}</span>
            <Typography sx={{
              fontSize: '1rem', marginTop: '5px',
              color: Colors.mediumGray, fontFamily: 'Jost'
            }}>POSITION</Typography>
            <Typography sx={{ fontFamily: 'Jost', fontSize: '1.1rem' }}>{contact.position || `Not Specified`}</Typography>
          </Stack>

        </AccordionSummary>
        <Divider />
        <AccordionDetails style={{ padding: 0 }}>
          <CardActionArea sx={{ padding: '8px 16px' }} onClick={handleEditClick}>
            {/* <SelectableCardContentRow iconComponent={<MilitaryTechIcon style={positionStyle} />} title={'Position'} mainText={contact.position}></SelectableCardContentRow> */}
            <SelectableCardContentRow iconComponent={<FontAwesomeIcon icon={faBuildingUser} style={departmentStyle} />} title={'Program/Department'} mainText={contact.program}></SelectableCardContentRow>
            <div style={rowStyles}>
              <SelectableCardContentRow iconComponent={<PhoneIphoneIcon style={phoneStyle} />} title={'Office number'} mainText={contact.officeNumber}></SelectableCardContentRow>
              <Tooltip title="Call Office Number" >
                <PhoneIcon onClick={(e) => makeCall(e, contact.officeNumber)} sx={{ fontSize: 32, cursor: 'pointer', marginRight: '10px' }} style={{ color: Colors.blue, marginLeft: '1px', cursor: 'pointer' }} />
              </Tooltip>
            </div>
            <div style={rowStyles}>
              <SelectableCardContentRow iconComponent={<PhoneIphoneIcon style={phoneStyle} />} title={'Mobile Number'} mainText={contact.mobileNumber}></SelectableCardContentRow>
              <Tooltip title="Call Mobile Number" >
                <PhoneIcon onClick={(e) => makeCall(e, contact.mobileNumber)} sx={{ fontSize: 32, cursor: 'pointer', marginRight: '10px' }} style={{ color: Colors.blue, marginLeft: '1px', cursor: 'pointer' }} />
              </Tooltip>
            </div>
            <SelectableCardContentRow iconComponent={<ModeCommentIcon style={commentStyle} />} title={'Comments'} mainText={contact.comment}></SelectableCardContentRow>
            {isAdmin && <StyledEditIcon onClick={handleEditClick} />}
          </CardActionArea>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default ContactsAccordian;